import { combineReducers } from 'redux';

import { AboutModalReducer } from '../components/admin/modals/SystemInformationModal/About/AboutModalReducer';
import { EmailModalReducer } from '../components/admin/modals/EmailModal/EmailModalReducer';
import { EmailTransactionModalReducer } from '../components/admin/modals/EmailTransactionModal/EmailTransactionModalReducer';
import { EreceiptModalReducer } from '../components/admin/modals/EreceiptModal/EreceiptModalReducer';
import { ErrorModalReducer } from '../components/admin/modals/ErrorModal/ErrorModalReducer';
import { LogoutModalReducer } from '../components/admin/modals/SystemInformationModal/Logout/LogoutModalReducer';
import { MassItemLocationModalReducer } from '../components/admin/location/modals/MassItemLocationModalReducer';
import { ReasonCodeCommentModalReducer } from '../components/admin/modals/ReasonCodeModal/ReasonCodeCommentModalReducer';
import { SmsModalReducer } from '../components/admin/modals/SmsModal/SmsModalReducer';
import { ViewPayloadModalReducer } from '../components/admin/kafka_log/modal/ViewPayloadModalReducer';
import { SpiModalReducer } from '../spi/components/SPIModalReducer';
import { CreateXeroAccountModalReducer } from '../components/admin/integrations/integration_tabs/xero/modal/CreateXeroAccountModalReducer';
import { CreateXeroTaxModalReducer } from '../components/admin/integrations/integration_tabs/xero/modal/CreateXeroTaxModalReducer';
import { CommonPromptModalReducer } from '../reducers/reducer_common';


const modalRootReducer = combineReducers({
  AboutModal: AboutModalReducer,
  EmailModal: EmailModalReducer,
  EmailTransactionModal: EmailTransactionModalReducer,
  EreceiptModal: EreceiptModalReducer,
  ErrorModal: ErrorModalReducer,
  LogoutModal: LogoutModalReducer,
  MassItemLocationModalReducer: MassItemLocationModalReducer,
  ReasonCodeCommentModal: ReasonCodeCommentModalReducer,
  SmsModal: SmsModalReducer,
  ViewPayloadModalReducer: ViewPayloadModalReducer,
  SpiModal: SpiModalReducer,
  CreateXeroAccountModal: CreateXeroAccountModalReducer,
  CreateXeroTaxModal: CreateXeroTaxModalReducer,
  CommonPromptModal: CommonPromptModalReducer,
});

export default modalRootReducer;
